import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const SidebarItem = ({ item, onItemClick }) => {
    if (!item.children) {
        return (
            <button
                type="button"
                onClick={() => onItemClick(item)}
                className={classNames(
                    item.current
                        ? "bg-gradient-to-r from-primary-500/20 via-orange-500/10 to-transparent text-primary-100 ring-1 ring-primary-400/60 shadow-sm shadow-primary-500/40"
                        : "text-slate-300 hover:text-white hover:bg-surfaceHighlight/70",
                    "group relative flex w-full items-center gap-x-3 rounded-2xl px-3 py-2 text-sm font-medium transition"
                )}
            >
                {/* active accent bar */}
                <span
                    className={classNames(
                        item.current ? "opacity-100" : "opacity-0 group-hover:opacity-40",
                        "pointer-events-none absolute inset-y-1 left-0 w-1 rounded-full bg-gradient-to-b from-primary-400 to-orange-500 transition"
                    )}
                />
                <span
                    className={classNames(
                        item.current
                            ? "bg-primary-400"
                            : "bg-surfaceHighlight group-hover:bg-slate-500",
                        "inline-block h-1.5 w-1.5 rounded-full"
                    )}
                />
                {item.icon && (
                    <item.icon
                        className={classNames(
                            item.current
                                ? "text-primary-300"
                                : "text-slate-400 group-hover:text-slate-200",
                            "h-5 w-5 shrink-0"
                        )}
                        aria-hidden="true"
                    />
                )}
                <span className="flex-1 truncate text-left">{item.name}</span>
            </button>
        );
    }

    return (
        <Disclosure as="div" defaultOpen={item.current}>
            {({ open }) => (
                <>
                    <Disclosure.Button
                        className={classNames(
                            item.current
                                ? "text-primary-100"
                                : "text-slate-300 hover:text-white hover:bg-surfaceHighlight/70",
                            "group relative flex w-full items-center gap-x-3 rounded-2xl px-3 py-2 text-sm font-medium transition"
                        )}
                    >
                        <span
                            className={classNames(
                                item.current
                                    ? "bg-primary-400"
                                    : "bg-surfaceHighlight group-hover:bg-slate-500",
                                "inline-block h-1.5 w-1.5 rounded-full"
                            )}
                        />
                        {item.icon && (
                            <item.icon
                                className={classNames(
                                    item.current
                                        ? "text-primary-300"
                                        : "text-slate-400 group-hover:text-slate-200",
                                    "h-5 w-5 shrink-0"
                                )}
                                aria-hidden="true"
                            />
                        )}
                        <span className="flex-1 text-left truncate">{item.name}</span>
                        <ChevronRightIcon
                            className={classNames(
                                open ? "rotate-90 text-primary-300" : "text-slate-500",
                                "h-4 w-4 shrink-0 transition-transform"
                            )}
                            aria-hidden="true"
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel as="ul" className="mt-1 space-y-1 pl-7">
                        {item.children.map((subItem) => (
                            <li key={subItem.name}>
                                <button
                                    type="button"
                                    onClick={() => onItemClick(subItem)}
                                    className={classNames(
                                        subItem.current
                                            ? "text-primary-200"
                                            : "text-slate-400 hover:text-slate-100",
                                        "block w-full text-left text-xs font-medium py-1.5"
                                    )}
                                >
                                    {subItem.name}
                                </button>
                            </li>
                        ))}
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    );
};

export default SidebarItem;
